// import { get, post, url} from '../service/ApiDecorator'
import { get, post, url} from '../http'


class Home {
//轮播图
@url('banner/list')
@get
getBanner(){}
 
}

export default new Home()
